import { render, staticRenderFns } from "./goodsMessage.vue?vue&type=template&id=1cdc7474&scoped=true"
import script from "./goodsMessage.vue?vue&type=script&lang=js"
export * from "./goodsMessage.vue?vue&type=script&lang=js"
import style0 from "./goodsMessage.vue?vue&type=style&index=0&id=1cdc7474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc7474",
  null
  
)

export default component.exports